import { useEffect } from 'react';

export function useSEO({ title, description, canonical, type = 'website', image }) {
  useEffect(() => {
    const base = 'ForesightRx';
    const fullTitle = title ? `${title} | ${base}` : `${base} | Living Partnering Intelligence for Pharma & Biotech`;
    document.title = fullTitle;

    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    if (description) {
      setMeta('name', 'description', description);
      setMeta('property', 'og:description', description);
      setMeta('name', 'twitter:description', description);
    }

    setMeta('property', 'og:title', fullTitle);
    setMeta('name', 'twitter:title', fullTitle);
    setMeta('property', 'og:type', type);

    if (image) {
      setMeta('property', 'og:image', image);
      setMeta('name', 'twitter:image', image);
    }

    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonical);
      setMeta('property', 'og:url', canonical);
    }

    return () => {
      document.title = `${base} | Living Partnering Intelligence for Pharma & Biotech`;
    };
  }, [title, description, canonical, type, image]);
}
